import util from '../util'

let controller = 'CobrancaRecorrenteMovimento'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
    Historico: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + "/Historico", dto)
    },
    HistoricoPaginado: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + "/HistoricoPaginado", dto)
    }
})
